var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailCampaigns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6984 1.17821C22.8518 0.317116 21.9038 -0.312087 21.1699 0.163722L1.45602 12.9446C0.819658 13.3572 0.856188 14.3002 1.52256 14.6623L7.10835 17.6976L7.97122 22.4435C8.0878 23.0846 8.77664 23.4447 9.36966 23.1746L13.7507 21.1788L17.4411 23.1841C18.0407 23.5099 18.7833 23.1527 18.903 22.4808L22.6984 1.17821ZM11.5506 19.9833L9.89441 19.0833L10.8382 16.898L9.29345 18.5353L9.70923 20.8221L11.5506 19.9833ZM12.4551 18.1985L17.1773 7.26455L8.6773 16.274L3.95507 13.708L20.3254 3.09474L17.1773 20.7646L12.4551 18.1985Z",
    fill: "#4F49DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCampaigns);
export default __webpack_public_path__ + "static/media/emailCampaigns.638de155.svg";
export { ForwardRef as ReactComponent };